const config = {
  apiKey: 'AIzaSyCqNzs82flHeL85-ky2-OUo6kIzkCCOKEQ',
  authDomain: 'carinibellaria-admin.firebaseapp.com',
  databaseURL: 'https://carinibellaria-admin.firebaseio.com',
  projectId: 'carinibellaria-admin',
  storageBucket: 'carinibellaria-admin.appspot.com',
  messagingSenderId: '460155312738'
}

export default config



// WEBPACK FOOTER //
// ./src/firebase_config/config.js